<span class="__dot  c-three-dots-dot"></span>
<span class="__dot  __dot--second  c-three-dots-dot"></span>
<span class="__dot  __dot--third  c-three-dots-dot"></span>
